import React from "react";
import Button from "react-bootstrap/Button";

const RecordedServiceButton = ({
  size,
  contactID,
  title,
  selected,
  ...rest
}) => {
  const openIncidentReport = () => {
    const url =
      process.env.REACT_APP_ORG +
      "/main.aspx?etc=10162&extraqs=%3F%5FCreateFromId%3D" +
      contactID +
      `%26%5FCreateFromType%3D2%26etc%10162&histKey=457048345&newWindow=true&pagetype=entityrecord&navbar=off`;
    // `%26%5FCreateFromType%3D2%26etc%10162%26ccx%5Fclientprogram%3D${selected.ccx_client_programid}%26ccx%5Fclientprogramname%3D${selected.ccx_name}&histKey=457048345&newWindow=true&pagetype=entityrecord&navbar=off`;
    window.open(url, "recordedService");
  };

  return (
    <Button {...rest} size={size || "sm"} onClick={() => openIncidentReport()}>
      {title || "Incident Report"}
    </Button>
  );
};

export default RecordedServiceButton;
